import React, { useEffect, useRef, useState } from 'react';
import { newsletterFormPropTypes } from './NewsletterFormPropTypes';
import Heading from '@Theme/natucare/modules/Footer/components/Heading/Heading';
import Icon from '@Theme/natucare/components/Icon/Icon';
import { validateEmail } from '@App/common/utils/validateEmail';
import { debounce } from '@App/common/utils/debounce';
import * as styles from './NewsletterForm.module.scss';
const NewsletterForm = ({
  heading,
  subheading,
  placeholder,
  consent,
  onSubscribe,
  buttonLabel,
  variant,
  subscriptionStatus
}) => {
  if (!heading && !subheading && !placeholder && !consent && !onSubscribe && !subscriptionStatus) {
    return null;
  }
  const emailRef = useRef(null);
  const {
    0: email,
    1: setEmail
  } = useState('');
  const {
    0: isValid,
    1: setIsValid
  } = useState(true);
  const {
    0: messageStatus,
    1: setMessageStatus
  } = useState({
    showLoading: false,
    showSuccess: false,
    showEmailTaken: false
  });
  const {
    isSending,
    isSubscribed,
    isEmailTaken
  } = subscriptionStatus;
  useEffect(() => {
    setMessageStatus({
      showLoading: isSending,
      showSuccess: isSubscribed,
      showEmailTaken: isEmailTaken
    });
  }, [isSending, isSubscribed, isEmailTaken]);
  const handleSubmit = e => {
    e.preventDefault();
    const currentEmail = emailRef.current.value;
    if (!validateEmail(currentEmail)) {
      setIsValid(false);
    }
    onSubscribe(currentEmail);
  };
  const handleEmailChange = debounce(e => {
    const newEmail = e.target.value;

    // Perform email validation
    const isValid = newEmail.length >= 3 ? validateEmail(newEmail) : true;
    setEmail(newEmail);
    setIsValid(isValid);
    setMessageStatus({
      showSuccess: false,
      showEmailTaken: false
    });
  }, 300);
  const handleEmailBlur = () => {
    if (email === '') {
      setIsValid(true);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles.root} ${styles[`root${variant}`]}`
  }, heading && /*#__PURE__*/React.createElement(Heading, {
    heading: heading
  }), subheading && /*#__PURE__*/React.createElement("p", {
    className: styles.rootSubheading
  }, subheading), /*#__PURE__*/React.createElement("form", {
    className: styles.rootForm,
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "email",
    className: styles.rootFormLabel
  }, "Email:"), /*#__PURE__*/React.createElement("input", {
    id: "email",
    type: "text",
    ref: emailRef,
    onChange: handleEmailChange,
    onBlur: handleEmailBlur,
    required: true,
    placeholder: placeholder,
    className: styles.rootFormInput
  }), /*#__PURE__*/React.createElement("button", {
    disabled: messageStatus.showLoading,
    type: "submit",
    className: styles.rootFormButton
  }, !messageStatus.showLoading && /*#__PURE__*/React.createElement("span", {
    className: styles.rootFormButtonLabel
  }, buttonLabel), messageStatus.showLoading && /*#__PURE__*/React.createElement(Icon, {
    name: "loading",
    classname: styles.rootFormButtonLoader
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.rootFormStatus,
    role: messageStatus.showSuccess || messageStatus.showEmailTaken || !isValid ? 'alert' : null
  }, !isValid && /*#__PURE__*/React.createElement("p", {
    className: styles.rootFormStatusInvalid
  }, "wpisany email jest niepoprawny"), messageStatus.showSuccess && isValid && /*#__PURE__*/React.createElement("p", {
    className: styles.rootFormStatusSubscribed
  }, "wys\u0142ali\u015Bmy zni\u017Ck\u0119"), messageStatus.showEmailTaken && isValid && /*#__PURE__*/React.createElement("p", {
    className: styles.rootFormStatusEmailTaken
  }, "wpisany email jest ju\u017C wykorzystany"))), consent && /*#__PURE__*/React.createElement("p", {
    className: styles.rootConsent,
    dangerouslySetInnerHTML: {
      __html: consent
    }
  }));
};
export default NewsletterForm;